import ILanguagePackage from "../ILanguagePackage";

const English: ILanguagePackage = {
    name: 'English',
    header: "User Guide",
    content: [
        {
            heading: "General Information",
            id: 'general-info',
            content: [
                {
                    type: 'text',
                    content:
                        "This system is an extension of the VIPER tool, created to help testers, developers and other "+
                        "participants of the scraping process in solving their daily tasks. The main function of "+
                        "ValidationRuler is to search for unique phrases and attributes inherent in documents of one or "+
                        "another type for a specific product category. In addition, the application provides an "+
                        "opportunity to compare the data of an excel table with its previous snapshots (or to compare "+
                        "two snapshots), which can be useful when conducting retesting. The same tool allows you "+
                        "to view the data of an excel table if it cannot be opened in VIPER due to the excessive size of "+
                        "the data.",
                    links: [{title: "VIPER", href: "https://dataforspec.com/"}]
                },
                {
                    type: 'text',
                    content:
                        "The functionality of the system will continue to expand as new challenges are identified. The "+
                        "full list of current capabilities can be seen in the [[lnk]] shown in Figure 1. It can be "+
                        "accessed by any authorized user by clicking on the name 'Validation Ruler' in the upper left "+
                        "corner of each screen. More details about the functionality will be described in the following "+
                        "sections.",
                    links: [{title: "main menu", href: "https://validationrulerapp.web.app/"}]
                },
                {
                    type: 'image',
                    content: {
                        imgId: 1,
                        src: '/manual/main_menu.png',
                        description: "The main menu and (highlighted) the main way to get to it."
                    }
                },

            ]
        },
        {
            heading: "Authorization",
            id: 'authorization',
            content: [
                {
                    type: 'text',
                    content:
                        "To access the functionality of the system, you must be authorized. This uses the credentials "+
                        "provided by the [[lnk]]. For convenience, it is customary to use [[lnk]] login data, in "+
                        "which case the dfs access token will be generated automatically. The user remains authorized "+
                        "until they log out of their account manually using the button in the upper right corner of each "+
                        "page, or until they reach a period of inactivity of 7 days.",
                    links: [
                        {title: "administrator", href: "https://t.me/wanna_be_a_cat_bot"},
                        {title: "VIPER", href: "https://dataforspec.com/"},
                        {title: "VIPER", href: "https://dataforspec.com/"}
                    ]
                },
                {
                    type: 'text',
                    content:
                        "If the user asked the [[lnk]] to register him with other login data, different from those "+
                        "used in [[lnk]] - at the first login, the system will also require entering the VIPER access token. "+
                        "You can find it in the Authorization header of any [[lnk]] request, as shown in Figure 3. To do "+
                        "this, while on any of its pages and being authorized, open the developer console (in most "+
                        "browsers - by pressing F12), find and open the Network tab, refresh the page, and in the list "+
                        "of requests find one of the document type and click on it, as shown in Figure 2.",
                    links: [
                        {title: "administrator", href: "https://t.me/wanna_be_a_cat_bot"},
                        {title: "VIPER", href: "https://dataforspec.com/"},
                        {title: "VIPER", href: "https://dataforspec.com/"},
                    ]
                },
                {
                    type: 'image',
                    content: {
                        imgId: 2,
                        src: '/manual/dev_console_1.png',
                        description: "Network tab of the developer console and a document request."
                    }
                },
                {
                    type: 'text',
                    content:
                        "After selecting the required request, you need to open the Headers tab (usually opened by "+
                        "default), find the Request Headers section, find the line with the Authorization header and "+
                        "copy its value (without the word Basic!), as shown in Figure 3. The received token must be "+
                        "entered in the appropriate the ValidationRuler system field.",
                },
                {
                    type: 'image',
                    content: {
                        imgId: 3,
                        src: '/manual/dfs_token.png',
                        description: "Searching for the authorization header and receiving the VIPER token."
                    }
                },
            ]
        },
        {
            heading: "Account Creation",
            id: 'sign-up',
            content: [
                {
                    type: 'text',
                    content:
                        "If the user has an account in [[lnk]], but still does not have access to the ValidationRuler "+
                        "system, he can either contact one of the administrators, or register himself using a VIPER "+
                        "token, the receipt of which is described in detail in [[lnk]]. To do this, on the login page, "+
                        "click on the inscription 'or Sign Up' under the login button, and then enter the VIPER token in "+
                        "the pop-up window. The user will then either receive an error message or be able to log in "+
                        "with their [[lnk]] credentials.",
                    links: [
                        {title: "VIPER", href: "https://dataforspec.com/"},
                        {title: "previous section", href: "#authorization"},
                        {title: "VIPER", href: "https://dataforspec.com/"},
                    ]
                },
            ]
        },
        {
            heading: "Search for keywords and phrases",
            id: 'rules-search',
            content: [
                {
                    type: 'text',
                    content:
                        "The categories page is divided into several parts. On the left is a list of user categories, "+
                        "where you can create a new category, and choose to view details or delete an existing one. The "+
                        "central part of the page is the working area, where the details of the category and possible "+
                        "actions with it are displayed. The basic category page is shown in Figure 4.",
                },
                {
                    type: 'image',
                    content: {
                        imgId: 4,
                        src: '/manual/cat_screen.png',
                        description: "Categories page. One category has been created but not opened."
                    }
                },
                {
                    type: 'text',
                    content:
                        "After selecting a category from the list, it appears in the workspace. At the top is a card "+
                        "with basic information:",
                },
                {
                    type: 'u-list',
                    content:
                        ["Category Number", "Manufacturer", "Category Name", "Date of Creation", "Status"],
                },
                {
                    type: 'text',
                    content:
                        "There are 5 buttons below: ",
                },
                {
                    type: 'u-list',
                    content: [
                        "'Perform 1 step' - tries to perform the necessary actions to move the category to the next "+
                        "status. Each such step can take from a few seconds to 40 minutes, depending on the size of the "+
                        "category and the complexity of the operation. ",

                        "'Perform all steps' - in order not to monitor the page all this time to start the next stage of "+
                        "processing, forces the category to go through all stages at once and reach either the final "+
                        "state (Attributes_Found) or an error, if one occurs during the processing. ",

                        "'Reload category' - allows you to reload the table from [[lnk]] and, if desired, go "+
                        "through all the operations again.",

                        "'View Excel' - redirects you to the [[lnk]] for this category.",

                        "'View PVR' - redirects you to the [[lnk]] for this category."
                    ],
                    links: [
                        {title: "VIPER", href: "https://dataforspec.com/"},
                        {title: "Excel Viewer", href: "/user-guide#excel-diff"},
                        {title: "PVR Viewer", href: "/user-guide#pvr"},
                    ]
                },
                {
                    type: 'text',
                    content: "The 'Reload Category' button is not available when the category has just been created, "+
                        "and the first two - when the category has reached its final state. The category details page "+
                        "is shown in Figure 5.",
                },
                {
                    type: 'image',
                    content: {
                        imgId: 5,
                        src: '/manual/cat_details.png',
                        description: "Category details page."
                    }
                },
                {
                    type: 'text',
                    content:
                        "After the system performs all the necessary operations to search for keywords and attributes, "+
                        "the results will appear on the page. The user will be able to switch between document tabs and "+
                        "view key phrases or attributes of his choice. Both will contain information about the "+
                        "documents in which they were found and in which they were not. The page with the obtained "+
                        "results is shown in Figure 6.",
                },
                {
                    type: 'image',
                    content: {
                        imgId: 6,
                        src: '/manual/cat_results.png',
                        description: "A page with search results for phrases and attributes."
                    }
                },
                {
                    type: 'text',
                    content:
                        "Also, a field appears at the bottom of the page that allows the user to perform an analysis "+
                        "for a specific phrase and check in which documents it occurs. After receiving the results of "+
                        "such an analysis, the user can switch between the tabs of the documents to make sure that the "+
                        "phrase is unique for a certain type. The result of such a search is shown in Figure 7.",
                },
                {
                    type: 'image',
                    content: {
                        imgId: 7,
                        src: '/manual/custom_phrase_test.png',
                        description: "Phrase analysis results page."
                    }
                },
                {
                    type: 'text',
                    content:
                        "Currently, this is all available functionality from this area. In the future, it will be "+
                        "improved and expanded as soon as new requirements or ideas appear.",
                },
            ]
        },
        {
            heading: "Comparison of table snapshots",
            id: 'excel-diff',
            content: [
                {
                    type: 'text',
                    content:
                        "When scraping, you should not forget one feature of this industry: data often changes. And it "+
                        "can be difficult, or even unrealistic, to visually monitor such changes. Fortunately, [[lnk]] "+
                        "provides tools for comparison with data in the database. But what if there is a need to perform "+
                        "a comparison with an earlier version of data that is not yet in release?",
                    links: [{title: "VIPER", href: "https://dataforspec.com/"}]
                },
                {
                    type: 'text',
                    content:
                        "Just for such purposes ValidationRuler provides the functionality of comparing the data "+
                        "of two table snapshots. All that is required for this is to enter their category number and "+
                        "creation time (dt parameter of the snapshot link). If it is necessary to compare the data of "+
                        "the current table - the first of dt can be left blank.",
                },
                {
                    type: 'text',
                    content:
                        "In order to find a snapshot of data for a certain date, click on the 'HISTORY' button in the "+
                        "upper right corner of the screen on the category page in [[lnk]] (Figure 8). In the resulting "+
                        "table, select the row with the text 'New Excel file loaded' for the desired date and click on "+
                        "the 'View Excel' button next to it (Figure 9). On the received page, in the url bar, you can "+
                        "find the dt parameter, which we actually need (Figure 10).",
                    links: [{title: "VIPER", href: "https://dataforspec.com/"}]
                },
                {
                    type: 'image',
                    content: {
                        imgId: 8,
                        src: '/manual/history_location.png',
                        description: "Location of the 'HISTORY' button."
                    }
                },
                {
                    type: 'image',
                    content: {
                        imgId: 9,
                        src: '/manual/snapshot_location.png',
                        description: "Finding the required data snapshot."
                    }
                },
                {
                    type: 'image',
                    content: {
                        imgId: 10,
                        src: '/manual/dt_location.png',
                        description: "The location of the dt parameter."
                    }
                },
                {
                    type: 'text',
                    content:
                        "After entering the necessary parameters and pressing the 'Compare' button, the process of "+
                        "downloading and comparing the tables will begin, which can take up to 5 minutes. At the end "+
                        "of the processing, the user will receive a table of changes, as shown in Figure 11. In it, the "+
                        "color of the column (red or green) means that such an attribute was previously present, but "+
                        "now it has disappeared, or vice versa, it just appeared. In turn, the lines can also have a "+
                        "different color depending on their status. Unchanged will have the background color. New ones "+
                        "will become green, disappeared - red, and partially changed in non-essential columns - blue. "+
                        "Columns of documents, images and links are considered non-essential, as well as any others, "+
                        "if they are marked as new or missing. Moreover, if it is possible to determine, based on the "+
                        "value of which cell, the line acquired a certain status - such a cell will be highlighted in "+
                        "a slightly brighter color. The exception is the modified (blue) lines, in which one of the "+
                        "attributes appeared or disappeared due to the addition or disappearance of an entire column. "+
                        "For them, the values in these columns (already colored) will not be highlighted in a brighter "+
                        "color additionally.",
                },
                {
                    type: 'image',
                    content: {
                        imgId: 11,
                        src: '/manual/cmp_result.png',
                        description: "The result of comparing the current table of category 432 with an older snapshot."
                    }
                },
                {
                    type: 'text',
                    content:
                        "You can also refer to a snapshot by its index, without using a timestamp from history. In this "+
                        "case, a negative index is used. As mentioned, for the most recent snapshot you can leave the "+
                        "field empty, for the previous one you can use index -1, for the one before that - "+
                        "index -2, and so on.",
                    links: []
                },
                {
                    type: 'text',
                    content:
                        "In the upper right corner of the page there are 4 checkboxes of different colors. By selecting "+
                        "or unselecting them, you can choose rows with which status you want to see. For example, if "+
                        "you only need deleted rows - you can unselect all checkboxes except the red one.",
                    links: []
                },
                {
                    type: 'text',
                    content:
                        "Also, this tool allows you to simply view the current table (or any snapshot). To do this, you "+
                        "need to leave both fields blank (or fill them with the same dt or index values). This can be useful in "+
                        "cases where the table cannot be opened in [[lnk]] due to its large size. Validation Ruler is "+
                        "better optimized, so it allows you to open tables with even 60,000 rows without problems, and "+
                        "maybe more, so far there was simply no way to check it.",
                    links: [{title: "VIPER", href: "https://dataforspec.com/"}]
                },
            ]
        },
        {
            heading: "PVR View",
            id: 'pvr',
            content: [
                {
                    type: 'text',
                    content:
                        "Another issue that [[lnk]] users may encounter is PVR loading problems due to lack of RAM. "+
                        "Just for such cases ValidationRuler provides an opportunity to view this report in a more "+
                        "optimized way. To do this, select the [[lnk]] option in the main menu, enter the category "+
                        "number in the field and click the 'Load PVR' button. After loading the data, the user will be "+
                        "able to select the type of files for which he wants to view the problems found. The table will "+
                        "display the same content as the original [[lnk]] page, as shown in Figure 12.",
                    links: [
                        {title: "VIPER", href: "https://dataforspec.com/"},
                        {title: "'PVR Documents'", href: "/pvr"},
                        {title: "VIPER", href: "https://dataforspec.com/"},
                    ]
                },
                {
                    type: 'image',
                    content: {
                        imgId: 12,
                        src: '/manual/cat_pvr.png',
                        description: "Page view with PVR for category 239."
                    }
                },
                {
                    type: 'text',
                    content:
                        "It should be noted that only problems with files of various types will be displayed on this "+
                        "page. Missing values of other columns can be tracked by filtering values by 'MISSING' in the "+
                        "Excel table view.",
                },
            ]
        },
        {
            heading: "Check Intersections",
            id: 'healthcheck',
            content: [
                {
                    type: 'text',
                    content:
                        "Sometimes filters on manufacturers' websites work in such a way that the same products fall "+
                        "into several categories at once. Such duplication would be critical for [[lnk]] system. However, "+
                        "this problem is practically impossible to catch manually. That is why the functionality "+
                        "for searching for category intersections was developed.",
                    links: [
                        {title: "SpecID", href: "https://project.spec-id.com/products/advancedSearch"},
                    ]
                },
                {
                    type: 'text',
                    content:
                        "The flow is pretty easy and straightforward. You just need to select the manufacturer from the "+
                        "list, as shown on the Figure 13, and press the 'Analyze' button. The system will try to load the "+
                        "previous check result if such exists or generate a new report. This can take a very long time, up "+
                        "to an hour, depending on the number of categories and their sizes. The system checks if there are "+
                        "some rows with the same URL, name, Size and (optionally) Shape common for different categories. "+
                        "A row with not specified Shape is considered a duplicate of rows with Shape if the other "+
                        "attributes match. Sometimes in the intersection report you may see several rows that look the "+
                        "same. But they actually have different URLs, and that's why each of them is included into the "+
                        "table. The result of such checks is shown on the Figure 14.",
                    links: []
                },
                {
                    type: 'image',
                    content: {
                        imgId: 13,
                        src: '/manual/intersections_manufacturer_selection.png',
                        description: "The list of available manufacturers."
                    }
                },
                {
                    type: 'image',
                    content: {
                        imgId: 14,
                        src: '/manual/intersections_result.png',
                        description: "Intersections report for Gerflor manufacturers. A lot of intersections found, some of them look the same but have different URLs."
                    }
                },
                {
                    type: 'text',
                    content:
                        "You can always re-analyze the manufacturer and load the fresh report by pressing the "+
                        "'Rerun analysis' button. The second button ('Show cat sizes') allows us to check the number of "+
                        "categories and their sizes. It may be useful for product managers.",
                },
            ]
        },
        {
            heading: "Manage Users (for admins)",
            id: 'users-management',
            content: [
                {
                    type: 'text',
                    content:
                        "If you are an admin, there is a 'Manage Users' tab in the main menu. It's page contains a left "+
                        "sidebar with a list of all users and a main area with selected user's details and available actions. "+
                        "Initially, this page was also planned to allow viewing of the user's recent actions, but this "+
                        "functionality was later rejected as unnecessary. The user management page is shown in Figure 15.",
                },
                {
                    type: 'image',
                    content: {
                        imgId: 15,
                        src: '/manual/user_management.png',
                        description: "User management page."
                    }
                },
                {
                    type: 'text',
                    content:
                        "Here you can create new user account by clicking the button in the lower left corner of the "+
                        "page and entering the credentials (it is recommended to use [[lnk]]'s credentials for better "+
                        "integration). You can also remove users if they are lower than you in access rights, promote "+
                        "regular users to administrators, and superadmins can also demote administrators back to regular "+
                        "users or create new superadmins.",
                    links: [
                        {title: "VIPER", href: "https://dataforspec.com/"},
                    ]
                },
            ]
        },
        {
            heading: "Logging",
            id: 'logs',
            content: [
                {
                    type: 'text',
                    content:
                        "Every system has various problems from time to time. And it is important to be able to track it. "+
                        "This is why there is a special page for viewing logs in the main menu. On it, there is a panel "+
                        "at the top of the screen for choosing the log level, as well as a form for choosing the maximum "+
                        "number of displayed lines. By default, data is taken from the most recent files, but a special "+
                        "checkbox allows you to include older data as well, if there is a need for it. Figure 16 shows "+
                        "the INFO level log review page.",
                },
                {
                    type: 'image',
                    content: {
                        imgId: 16,
                        src: '/manual/logs.png',
                        description: "Log view page."
                    }
                },
            ]
        },
        {
            heading: "Additional information",
            id: 'additional',
            content: [
                {
                    type: 'text',
                    content:
                        "Next steps in ValidationRuler development:",
                },
                {
                    type: 'o-list',
                    content: [
                        "Adding a new type of buttons, in addition to the already existing important actions and "+
                        "destructive actions - informational buttons, most likely blue or gray in color, to logically "+
                        "separate different types of actions;",

                        // "Moving the user control panel to a separate page, adding the function of viewing user "+
                        // "categories and managing them (removal);",

                        "Adding icons to buttons that could replace text at small screen sizes;",

                        "Changing the design to a responsive one to allow users to work conveniently from any device.",
                    ],
                },
                {
                    type: 'text',
                    content:
                        "For now, this is all the important information about the system. More information can be found [[lnk]].",
                    links: [{title: "here", href: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"}]
                },
            ]
        },
    ],
    additional: {
        tableOfContents: "Table of Contents",
        picture: "Figure"
    },
}

export default English;